
<div class="modal fade modal--alert" id="call-us__modal" tabindex="-1" role="dialog"
  aria-labelledby="call-us__modal" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content modal-alert modal-alert--alt">
      <div class="modal-alert__heading">
        <div class="container">
          <div class="modal-alert__avatar modal-alert__avatar--alt">
            <img src="assets/0/avatar/chat.png" class="img-fluid" alt="">
          </div>
        </div>
      </div>
      <div class="modal-alert__content">
        <div class="container">
          <div class="rte">
            <h3>Request a call</h3>
            <p>Submit your details and someone will get in touch as soon as possible!</p>
          </div>


          <form [formGroup]="contactForm">
            <div class="form-group form-group--sm mt-30">
              <label>Full Name</label>
              <input type="text" formControlName="name" class="form-control">
              @if (contactForm.get('name')?.errors?.required && formSubmitted) {
                <div class="invalid-feedback">
                  Please enter name.
                </div>
              }
            </div>

            <div class="form-group form-group--sm">
              <label>Mobile Number</label>
              <input type="tel" formControlName="contactNumber" class="form-control">
              @if (contactForm.get('contactNumber')?.errors?.required && formSubmitted) {
                <div class="invalid-feedback">
                  Please enter contact number.
                </div>
              }
            </div>
            <div class="form-group form-group--sm">
              <label>Email</label>
              <input type="email" formControlName="email" class="form-control">
              @if (contactForm.get('email')?.errors?.required && formSubmitted) {
                <div class="invalid-feedback">
                  Please enter email.
                </div>
              }
            </div>
            <div class="form-group form-group--sm">
              <label>How can we help?
                <small class="ml-5 text-muted">
                  ({{contactForm.get('message')?.value?.length ? contactForm.get('message')?.value?.length : 0}} /
                  {{maxCharacters}} characters)
                </small>
              </label>
              <textarea class="form-control" formControlName="message" maxlength="1000"></textarea>
              @if (contactForm.get('message')?.errors?.required && formSubmitted) {
                <div class="invalid-feedback">
                  Please enter a message.
                </div>
              }
              @if (contactForm.get('message')?.errors?.maxlength && formSubmitted) {
                <div class="invalid-feedback">
                  Message should contain a maximum of 1000 characters.
                </div>
              }
            </div>
          </form>
        </div>
      </div>

      <div class="modal-alert__button">
        <div class="container">
          <a href="javascript:void(0)" class="button button--lg button--secondary" data-dismiss="modal">Cancel</a>
          <a href="javascript:void(0)"
            (click)="submitPleaseCallMe()"
            [attr.disabled]="buttonDisabled ? true : null"
            class="button button--lg button--primary">
            Request Call
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
